"use client";

import { Analytics } from "@vercel/analytics/next";
import { useEffect, useRef } from "react";
import { supabase } from "@/lib/supabase";

/**
 * Vercel Analytics wrapper that excludes logged-in admin users from tracking.
 * - Production only: Vercel Analytics automatically ignores dev/localhost.
 * - Admin exclusion: Checks Supabase auth session and skips tracking for logged-in users.
 */
export default function AnalyticsWrapper() {
  const isAdmin = useRef(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      isAdmin.current = !!data.session;
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      isAdmin.current = !!session;
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <Analytics beforeSend={(event) => (isAdmin.current ? null : event)} />
  );
}
